module.exports = __webpack_public_path__ + "static/media/compote.9f70dfcb.svg";